import { useTheme } from "@emotion/react";
import { Button } from "@mui/material";
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useConfig } from "../config/configContext";
import { Room } from "../config/parsedConfig";
import { useCurrentSession } from "../hooks/useCurrentSession";
import { getThemeColor } from "../utils/color";
import { convertSecondsToDurationString } from "../utils/time";
import NotFound from "./404";
import { UpcomingSessionInfo } from "./Room";


const PeekRoomDisplay = ({ room }: { room: Room }) => {
    const {
        currentSession,
        upcomingSession,
        upcomingSessionIsTomorrow,
        currentSessionRunningTime,
        timeUntilUpcomingSession
    } = useCurrentSession(room);

    const theme = useTheme() as any;
    const roomColor = getThemeColor(theme, room.color || 'primary');

    //link to room page: domain of current page + "/room/" + room.name
    const roomUrl = window.location.origin + "/room/" + room.name;
    const triggerOpenPopup = useCallback(() => {
        if (window.parent !== window) {
            //if this app is running in an iframe, send a message to the parent window to navigate to the room
            const msg = { openPopup: roomUrl };
            console.log("sending message to parent window: ", msg);
            window.parent.postMessage(msg, '*');
        } else {
            //else, open a new tab with the room-url
            console.log("opening in this tab: ", roomUrl);
            window.location.href = roomUrl;
        }

    }, [roomUrl]);

    const backgroundImage = currentSession ? room.peek.imageSession : room.peek.imagePause;
    const backgroundImageHover = currentSession ? room.peek.imageSessionHover : room.peek.imagePauseHover;

    return <div className="peekroom room responsive outside">
        <div className="room-image-container">
            <div className="layer img door"
                style={{ backgroundImage: `url(${backgroundImage})`, cursor: "pointer" }}
                title={room.peek.buttonText + "   ▶"}
                onClick={triggerOpenPopup}
            >
            </div>
            {backgroundImageHover &&
                <div className="layer img door-open"
                    style={{ backgroundImage: `url(${backgroundImageHover})`, cursor: "pointer" }}
                    title={room.peek.buttonText + "   ▶"}
                    onClick={triggerOpenPopup}
                >
                </div>
            }
        </div>
        <div className="room-info">
            <div className="text-center">
                {currentSession
                    ? // display current session name, and time that is has been running for
                    <p>
                        <span className="text-bold" style={{ color: roomColor }}>{currentSession.name}</span><br />
                        läuft seit <span className="text-bold">{convertSecondsToDurationString(currentSessionRunningTime)}</span>.
                    </p>
                    : // display upcoming session: name, start time of day (local time! local time format!)
                    <UpcomingSessionInfo
                        timeUntilUpcomingSession={timeUntilUpcomingSession}
                        upcomingSession={upcomingSession}
                        upcomingSessionIsTomorrow={upcomingSessionIsTomorrow}
                        roomColor={roomColor} />
                }
            </div>
        </div>
        <div className="room-info-button text-center">
            <Button
                variant='contained'
                color={room.color as any}
                size='large'
                fullWidth={false}
                onClick={triggerOpenPopup}
                sx={{
                }}
            >
                {room.peek.buttonText} &nbsp; ▶
            </Button>
        </div>
    </div>;
}

export const PeekRoomRoute = () => {
    const { roomName } = useParams();
    const config = useConfig();
    const room = roomName && config.rooms[roomName];
    if (!room) {
        return (
            <NotFound />
        );
    }
    return <PeekRoomDisplay room={room} />;
};
